<template>
  <form class="space-y-3 -mt-4" @submit.prevent="handleLoginByCnpj">
    <h1
      class="text-2xl font-extralight text-gray-200 flex justify-center text-center font-mind-force"
    >
      Acesso seguro
    </h1>

    <div class="space-y-8">
      <!-- CNPJ -->
      <div>
        <input
          v-model="cnpj"
          type="text"
          placeholder="CNPJ"
          class="w-full bg-transparent border-b border-gray-600 focus:border-red-500 focus:outline-none py-2 text-gray-200 placeholder-gray-500 transition-all duration-300 text-center"
          @input="cnpj = maskCnpj(cnpj)"
        />
      </div>

      <p v-if="errorMessage" class="text-sm text-red-400 text-center">
        {{ errorMessage }}
      </p>

      <!-- Login Button -->
      <button
        type="submit"
        :disabled="loading"
        class="w-full bg-red-600 hover:bg-red-700 transition-all py-3 rounded-lg text-white font-medium shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {{ loading ? "Entrando..." : "Entrar" }}
      </button>
    </div>
  </form>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  loginCompanyByCnpj,
  loginCompanyByToken,
  getCompanyMe,
} from "@/services/auth/companyAuthService";

const router = useRouter();
const route = useRoute();

const cnpj = ref("");
const loading = ref(false);
const errorMessage = ref("");

onMounted(() => {
  const token = route.query.token;

  if (token) {
    handleLoginByToken(token);
  }
});

async function handleLoginByCnpj() {
  errorMessage.value = "";

  const digits = (cnpj.value || "").replace(/\D/g, "");

  if (!digits) {
    errorMessage.value = "Informe o CNPJ.";
    return;
  }

  if (digits.length !== 14) {
    errorMessage.value = "CNPJ inválido.";
    return;
  }

  loading.value = true;

  try {
    const { data } = await loginCompanyByCnpj({
      cnpj: cnpj.value,
    });

    if (data.success) {
      await getCompanyMe();
      router.push({ name: "enter" });
    }
  } catch (error) {
    errorMessage.value =
      error?.response?.data?.message || "Não foi possível realizar o login.";
  } finally {
    loading.value = false;
  }
}

async function handleLoginByToken(token) {
  loading.value = true;
  errorMessage.value = "";

  try {
    const { data } = await loginCompanyByToken({ token });

    if (data.success) {
      await getCompanyMe();

      router.replace({ name: "enter" });
    }
  } catch (error) {
    errorMessage.value =
      error?.response?.data?.message ||
      "Não foi possível validar o acesso da empresa.";
  } finally {
    loading.value = false;
  }
}

function maskCnpj(value) {
  const v = (value || "").replace(/\D/g, "").slice(0, 14);
  let masked = "";

  if (v.length <= 2) masked = v;
  else if (v.length <= 5) masked = `${v.slice(0, 2)}.${v.slice(2)}`;
  else if (v.length <= 8)
    masked = `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`;
  else if (v.length <= 12)
    masked = `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`;
  else
    masked = `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(
      8,
      12
    )}-${v.slice(12)}`;

  return masked;
}
</script>
